import { axiosApi } from './axios.api';
import { apiErrorMessage } from './ApiError';

export interface AppNotification {
  id: number;
  kind: 'order_created' | 'order_status_changed' | 'payment' | 'stock_import' | 'birthday' | string;
  title: string;
  body: string | null;
  url: string | null;
  read: boolean;
  created_at: string;
}

export interface NotificationsResponse {
  notifications: AppNotification[];
  unread_count: number;
}

const url = '/api/notifications';

export const getNotificationsApi = async (): Promise<NotificationsResponse | undefined> => {
  try {
    const response = await axiosApi.get<NotificationsResponse>(url);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const markAllReadApi = async (): Promise<void> => {
  try {
    await axiosApi.post(`${url}/mark_all_read`);
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const markOneReadApi = async (id: number): Promise<void> => {
  try {
    await axiosApi.post(`${url}/${id}/mark_read`);
  } catch {
    // silent
  }
};

// Legacy type aliases kept for any remaining references
export type Message = AppNotification;
export type Mention = AppNotification;
export type Notification = AppNotification;
